<template>
  <v-container fluid>
    <div>
      <search-results :query="query" />
      <div class="padding-bottom-2x">
        <autocomplete
          :search="search"
          :placeholder="hints"
          @submit="handleSubmit"
          :debounce-time="500"
          ref="autocompleteRef"
          :disabled="isDisabled"
        >
          <template #result="{ result }">
            <i
              class="material-icons room text-default"
              style="font-size: 18px; padding-bottom: 5px; padding-right: 5px"
            ></i>
            <!-- <a @click="addStop(result)">
              {{ result.address.freeformAddress }}</a
            > -->

            <a @click="addStop(result)"> {{ result.properties.label }}</a>
            <br />
          </template>
        </autocomplete>
        <div class="checkbox-container">
          <input
            type="checkbox"
            id="countrySearch"
            v-model="isCountrySpecificSearch"
          />
          <label for="countrySearch">Search only within the country</label>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import Autocomplete from "@trevoreyre/autocomplete-vue";
import { isStrictDoubleOrNumericString } from "@/utils/validation"; // Używamy aliasu @ lub pełnej ścieżki

const searchApiUrl = process.env.VUE_APP_MAPOSCOPE_SEARCH_API_SERVER;
const paramsK =
  "key=" + process.env.VUE_APP_MAPOSCOPE_SEARCH_MAP_API_SERVER_KEY;

export default {
  props: ["hints", "isOptimized", "isDisabled"],
  components: {
    Autocomplete,
  },
  data: () => ({
    address: "",
    name: "",
    value: "",
    results: [],
    selectedIndex: 0,
    country: "",
    isCountrySpecificSearch: true,
  }),
  methods: {
    search(input) {
      this.value = input;
      var url = `${searchApiUrl}`;
      var lang = navigator.language || navigator.userLanguage;
      url += "lang=" + lang;
      if (
        this.isCountrySpecificSearch &&
        localStorage.getItem("countryCode") !== null &&
        localStorage.getItem("countryCode").length == 2
      ) {
        url += "&boundary.country=" + localStorage.getItem("countryCode");
      }
      url += "&" + paramsK;
      var start_point_lat = this.$store.getters.getRouteData("start_point_lat");
      var start_point_lng = this.$store.getters.getRouteData("start_point_lng");
      if (
        isStrictDoubleOrNumericString(start_point_lat) &&
        isStrictDoubleOrNumericString(start_point_lng)
      ) {
        url += "&focus.point.lat=" + start_point_lat;
        url += "&focus.point.lon=" + start_point_lng;
      } else {
        if (
          isStrictDoubleOrNumericString(localStorage.getItem("latitude")) &&
          isStrictDoubleOrNumericString(localStorage.getItem("longitude")) !==
            null
        ) {
          url += "&focus.point.lat=" + localStorage.getItem("latitude");
          url += "&focus.point.lon=" + localStorage.getItem("longitude");
        }
      }

      if (localStorage.getItem("teamUid") != null) {
        url += "&uid=" + localStorage.getItem("teamUid");
      }

      url += "&text=";
      url += `${encodeURI(input)}`;
      return new Promise((resolve) => {
        if (input.length < 3) {
          return resolve([]);
        }

        fetch(url)
          .then((response) => response.json())
          .then((data) => {
            resolve(data.features);
          });
      });
    },
    // We want to display the title
    getResultValue: (result) => result.title,

    // Open the selected article in
    // a new window
    handleSubmit(result) {},
    handleUpdate(results, selectedIndex) {
      this.results = results;
      this.selectedIndex = selectedIndex;
    },
    addStop(result) {
      var name = result.properties.name;
      var address = result.properties.label;
      var country = result.properties.country;
      var fullAddress = result.properties.label;
      this.$emit("found-address", {
        name: name,
        address: address,
        lat: result.geometry.coordinates[1],
        lng: result.geometry.coordinates[0],
        country: country,
        fullAddress: fullAddress,
      });
      this.clear();
    },

    clear() {
      this.value = "";
      this.$refs.autocompleteRef.value = "";
      this.$refs.autocompleteRef.results = [];
    },

    onChange(event) {},
  },
  mounted() {},
  created() {},
};
</script>
<style scoped>
.checkbox-container {
  display: flex;
  align-items: center; /* Opcjonalnie: wyrównuje elementy pionowo do środka */
  gap: 10px; /* Opcjonalnie: dodaje małą przerwę między input a label */
}
/* KOREKTA WIZUALNA */
.checkbox-container label {
  /* Najczęściej wystarczy 1px lub 2px. Eksperymentuj! */
  margin-top: 6px;
}
</style>


